// @ts-nocheck

import { createSelector } from 'reselect';

import { getItemIdFromProps } from '../../selectors/_propsGetters_';
import { selectBasketMode, selectBasketStake } from '../../selectors/basket/basketPrimary.selector';
import { selectBasketShowResume, makeBasketItemSelector } from '../../selectors/basketCommon.selector';
import { selectBasketEnhancedItems } from '../../selectors/basketItems.selector';
import { BasketModes } from '../../types/basket';

const selectBasketKeyboardProps = createSelector(
  [
    selectBasketMode,
    selectBasketStake,
    selectBasketEnhancedItems,
    selectBasketShowResume,
    makeBasketItemSelector(),
    getItemIdFromProps,
  ],
  (mode, basketStake, items, showResume, item, itemIdModeSimple) => {
    const isModeSimple = mode === BasketModes.SIMPLE;
    const isOneSimpleBet = isModeSimple && items.length === 1;
    const isMultipleSimpleBets = isModeSimple && items.length > 1;

    let value = basketStake;
    let itemId = null;
    const isVisible =
      !showResume &&
      ((isOneSimpleBet && !itemIdModeSimple) ||
        (!isModeSimple && !itemIdModeSimple) ||
        (isMultipleSimpleBets && itemIdModeSimple));

    if (item && ((isOneSimpleBet && !itemIdModeSimple) || (isMultipleSimpleBets && itemIdModeSimple))) {
      itemId = item.oddId;
      value = item.stake;
    }

    return {
      isVisible,
      value,
      itemId,
    };
  },
);

export default selectBasketKeyboardProps;
